// extracted by mini-css-extract-plugin
export const spinnerWrapper = "YoutubePlayer__spinnerWrapper__7GOrT";
export const youtubePlayer = "YoutubePlayer__youtubePlayer__svbx-";